import { render, staticRenderFns } from "./LayoutDashboard.vue?vue&type=template&id=a3b2ec68&scoped=true"
import script from "./LayoutDashboard.vue?vue&type=script&lang=ts"
export * from "./LayoutDashboard.vue?vue&type=script&lang=ts"
import style0 from "./LayoutDashboard.vue?vue&type=style&index=0&id=a3b2ec68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b2ec68",
  null
  
)

export default component.exports